import { FormControl, FormLabel as FormLabelChakra } from "@chakra-ui/react"
import React from "react"

interface Props {
    readonly isRequired?: boolean
    readonly children: React.ReactNode
}

export default function FormLabel({ isRequired, children }: Props) {
    return (
        <FormControl isRequired={isRequired}>
            <FormLabelChakra>{children}</FormLabelChakra>
        </FormControl>
    )
}
